import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    channels: null,
    videos: null,
    themes: null,
    allThemes: false,
    currentVideo: null,
    related: null,
    videosShowSidebar: false,
    asc: true,
    sortBy: 'date',
    searching: false,
    searchTerm: null,
    searchResults: null,
    loading: true
  },
  mutations: {
    LOAD_START (state) {
      this.state.loading = true
    },
    LOAD_STOP (state) {
      this.state.loading = false
    },
    UPDATE_CHANNELS (state, payload) {
      state.channels = payload
    },
    UPDATE_RELATED (state, payload) {
      state.related = payload
    },
    UPDATE_VIDEOS (state, payload) {
      state.videos = payload
    },
    UPDATE_CURRENT_VIDEO (state, payload) {
      state.currentVideo = payload
    },
    UPDATE_THEMES (state, payload) {
      state.themes = payload
    },
    UPDATE_ALL_THEMES (state, payload) {
      state.allThemes = payload
    },
    START_SEARCHING (state) {
      state.searching = true
    },
    UPDATE_SEARCH_TERM (state, payload) {
      state.searchTerm = payload
    },
    STOP_SEARCHING (state) {
      state.searching = false
    },
    UPDATE_SEARCH_RESULTS (state, payload) {
      state.searchResults = payload
    },
    CLEAR_SEARCH_RESULTS (state) {
      state.searchResults = null
    },
    CLEAR_VIDEO (state) {
      state.currentVideo = null
    }
  },
  actions: {
    getChannels: function (context, force) {
      if (force || this.state.channels === null) {
        return new Promise((resolve, reject) => {
          Axios.get(`${process.env.API_ROOT}/channels`)
            .then(response => {
              let channels = response.data.channels.filter((el) => {
                return el.slug !== 'tate'
              })
              context.commit('UPDATE_CHANNELS', channels)
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    getVideos: function (context) {
      if (this.state.videos === null) {
        return Axios.get(`${process.env.API_ROOT}/videos`)
          .then(response => {
            context.commit('UPDATE_VIDEOS', response.data.videos)
          })
      } else {
        return Promise.resolve()
      }
    },
    updateCurrentVideo: function (context, payload) {
      if (payload.vimeoId) {
        return Axios.get(`${process.env.API_ROOT.replaceAll('soetv', 'vimeo')}/${payload.vimeoId}`)
          .then(response => {
            response.data.notSoeVideo = true
            response.data.isEmbed = true
            context.commit('UPDATE_CURRENT_VIDEO', response.data)
          })
      }
      if (this.state.currentVideo === null || payload.id !== this.state.currentVideo.id) {
        return Axios.get(`${process.env.API_ROOT}/video/${payload.id}`)
          .then(response => {
            response.data.video.isEmbed = (payload.originalTo.name === 'VideoEmbed' || payload.originalTo.name === 'VimeoVideoEmbed')
            context.commit('UPDATE_CURRENT_VIDEO', response.data.video)
          })
      } else {
        return Promise.resolve()
      }
    },
    getThemes: function (context) {
      if (this.state.themes === null) {
        return Axios.get(`${process.env.API_ROOT}/themes`)
          .then(response => {
            let themes = response.data.themes
            themes = themes.sort(function (a, b) {
              return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
            })
            context.commit('UPDATE_THEMES', themes)
          })
      } else {
        return Promise.resolve()
      }
    },
    getAllThemes: function (context) {
      if (!this.state.allThemes) {
        return Axios.get(`${process.env.API_ROOT}/tags`)
          .then(response => {
            let themes = response.data.tags
            themes = themes.sort(function (a, b) {
              return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
            })
            context.commit('UPDATE_ALL_THEMES', themes)
          })
      } else {
        return Promise.resolve()
      }
    },
    search: function (context, payload) {
      if (payload !== this.state.searchTerm) {
        context.commit('START_SEARCHING')
        context.commit('CLEAR_SEARCH_RESULTS')
        context.commit('UPDATE_SEARCH_TERM', payload)

        Axios.get(`${process.env.API_ROOT}/search?term=${payload}`)
          .then(response => {
            context.commit('UPDATE_SEARCH_RESULTS', response.data.videos)
            context.commit('STOP_SEARCHING')
            return true
          })
          .catch(error => {
            context.commit('STOP_SEARCHING')
            return error
          })
      }
    },
    getRelated: function (context, payload) {
      Axios.get(`${process.env.API_ROOT}/video/${payload}`)
        .then(response => {
          context.commit('UPDATE_RELATED', response.data.video.related)
          return true
        })
        .catch(error => {
          return error
        })
    },
    clearSearchResults: function (context) {
      context.commit('CLEAR_SEARCH_RESULTS')
    },
    clearVideo: function (context) {
      context.commit('CLEAR_VIDEO')
    },
    sortVideosByDuration: function (context) {
      let videosSorted = this.state.videos.sort(function (a, b) {
        return (a.duration > b.duration) ? 1 : ((b.duration > a.duration) ? -1 : 0)
      })

      if (this.state.sortBy === 'duration') {
        this.state.asc = !this.state.asc
      }
      this.state.sortBy = 'duration'

      if (this.state.asc) {
        videosSorted = videosSorted.reverse()
      }
      context.commit('UPDATE_VIDEOS', videosSorted)
    },
    sortVideosByDate: function (context) {
      let videosSorted = this.state.videos.sort(function (a, b) {
        return (a.created_at > b.created_at) ? 1 : ((b.created_at > a.created_at) ? -1 : 0)
      })

      if (this.state.sortBy === 'date') {
        this.state.asc = !this.state.asc
      }
      this.state.sortBy = 'date'

      if (this.state.asc) {
        videosSorted = videosSorted.reverse()
      }
      context.commit('UPDATE_VIDEOS', videosSorted)
    },
    sortVideosByTitle: function (context) {
      let videosSorted = this.state.videos.sort(function (a, b) {
        return (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0)
      })

      if (this.state.sortBy === 'title') {
        this.state.asc = !this.state.asc
      }
      this.state.sortBy = 'title'

      if (this.state.asc) {
        videosSorted = videosSorted.reverse()
      }
      context.commit('UPDATE_VIDEOS', videosSorted)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js